import windowBind,{setWindowSize} from './_windowBind';
import {isSizeSp} from './_checkDeviceSize';
export default class HeroFit {
    constructor() {
        this.headerHeight = 90*2;
    }

    setEvents() {
        this.getTarget();
        this.setValue();
        if (isSizeSp()) {
            this.resetWindowSize();
        } else {
            this.setTargetSize();
        }
    }
    
    resizeEvents() {
        this.setValue();
        if (isSizeSp()) {
            this.resetWindowSize();
        } else {
            this.setTargetSize();
        }

    }


    getTarget() {
        this.$target = $('.js-hero-fit .hero-background');
    }

    setValue() {
        setWindowSize();
    }

    setTargetSize() {
        this.$target.css({
            'height': (windowBind.height - this.headerHeight)
        });
    }

    resetWindowSize() {
        this.$target.css({
            'height': ''
        });
    }
}